// extracted by mini-css-extract-plugin
export default {"base":"components-Shared-Icon-themes-BGH-RD3-iconCheckmark__base--ldESW"};